import { combineReducers } from "@reduxjs/toolkit";
import userInfo from './Auth';
const reducers = combineReducers({
   userInfo,
});
export default reducers;